<template>
    <Playground/>
</template>

<script>
import Playground from '../components/Playground';


export default {
  name: 'Audio',
  components: {
    Playground,
  }
}
</script>
